<template>
  <el-table class="tb-c-head" :data="Dts" border>
    <el-table-column label="订单编号" prop="OrderNo" min-width="170" show-overflow-tooltip />
    <el-table-column label="工单编号" prop="WorkDocNo" min-width="170" show-overflow-tooltip />
    <el-table-column label="产品编号" prop="ProductNo" min-width="120" show-overflow-tooltip />
    <el-table-column label="产品名称" prop="ProductName" min-width="120" />
    <el-table-column label="生产数量" prop="Quantity" min-width="70" />
    <el-table-column label="排产数量" prop="ThisPlanQuantity" width="80" />
    <el-table-column label="已生产数量" prop="ThisReportQuantity" width="90" />
    <el-table-column label="完成率（%）" prop="CompletionRate" width="100" />
  </el-table>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default:() => {}
    }
  },
  data() {
    return {
      api: require("@/api/sy/user").default,
      Dts: [],
    };
  },
  methods: {
    setData(id) {
      console.log("setData", id);
      this.api.info(id).then((res) => {
        if (res.Code == 0) this.Dts = res.Data.Dts;
      });
    },
    clear() {
      this.Dts = [];
    },
  },
  watch: {
    data: {
      handler: function(newVal) {
        this.Dts = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true
    }
  }
};
</script>